import React from 'react';

interface MeridianLogoProps {
  className?: string;
  color?: string;
  showText?: boolean;
}

/**
 * Meridian Logo Component
 * Bar chart icon + "Meridian" text
 * Uses exact SVGs exported from Figma
 */
export const MeridianLogo: React.FC<MeridianLogoProps> = ({
  className = '',
  color = '#AACFFF',
  showText = true,
}) => {
  return (
    <div className={`flex items-center gap-[6px] ${className}`}>
      {/* Bar chart icon - exact SVG from Figma (Group 625413) */}
      <svg
        width='13'
        height='15'
        viewBox='0 0 13 15'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='12.8113'
          y='2.60726'
          width='11.5893'
          height='2.56906'
          transform='rotate(90 12.8113 2.60726)'
          fill={color}
        />
        <rect
          x='7.66443'
          y='4.90829'
          width='9.28825'
          height='2.56906'
          transform='rotate(90 7.66443 4.90829)'
          fill={color}
        />
        <rect
          x='2.56921'
          y='7.06228'
          width='7.13425'
          height='2.56906'
          transform='rotate(90 2.56921 7.06228)'
          fill={color}
        />
        <rect
          x='5.07019'
          y='0.0437317'
          width='4.82867'
          height='2.56906'
          transform='rotate(90 5.07019 0.0437317)'
          fill={color}
        />
        <rect
          x='10.2067'
          y='0'
          width='2.58942'
          height='2.56906'
          transform='rotate(90 10.2067 0)'
          fill={color}
        />
      </svg>

      {/* Meridian text - exact SVG from Figma (Group 625412) */}
      {showText && (
        <svg
          width='73'
          height='14'
          viewBox='0 0 73 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M67.3402 12.7661V13.5426H63.4399V12.7661C64.5233 12.7661 64.6136 12.73 64.6136 12.423V6.96991C64.6136 6.59072 64.5233 6.53655 64.1983 6.39209L63.3677 6.0129V5.61565L65.9137 4.87532H66.1665V6.48238C66.7082 5.77816 67.8819 4.87532 69.1097 4.87532C70.8612 4.87532 71.5474 6.28375 71.5474 7.8908V12.423C71.5474 12.73 71.6377 12.7661 72.7211 12.7661V13.5426H68.8208V12.7661C69.9042 12.7661 69.9945 12.73 69.9945 12.423V8.03526C69.9945 6.77128 69.4709 6.04901 68.3513 6.04901C67.4846 6.04901 66.6721 6.57266 66.1665 7.11436V12.423C66.1665 12.73 66.2568 12.7661 67.3402 12.7661Z'
            fill={color}
          />
          <path
            d='M60.8852 13.7231C60.0366 13.7231 59.3324 13.0911 59.206 12.1703C58.592 12.9828 57.4183 13.7231 56.3349 13.7231C55.1251 13.7231 54.2404 12.9828 54.2404 11.7549C54.2404 10.166 55.7932 9.06449 59.1337 8.37834V7.25882C59.1337 6.24764 58.6101 5.70593 57.5989 5.70593C56.8225 5.70593 56.1905 6.08513 56.1905 6.48238C56.1905 6.71711 56.353 6.82545 56.353 7.20465C56.353 7.71024 55.9738 8.07137 55.4502 8.07137C54.9626 8.07137 54.5112 7.69218 54.5112 7.07825C54.5112 5.83233 56.2447 4.87532 57.9781 4.87532C59.5852 4.87532 60.6866 5.43508 60.6866 7.20465V11.7188C60.6866 12.3689 61.0839 12.6397 61.4269 12.6397C61.77 12.6397 61.9867 12.5133 62.2395 12.3147L62.5103 12.8745C62.1312 13.3259 61.4992 13.7231 60.8852 13.7231ZM59.1337 9.15478C56.8947 9.66036 55.7752 10.2743 55.7752 11.448C55.7752 12.1883 56.2447 12.6397 56.9308 12.6397C57.7614 12.6397 58.4656 12.2425 59.1337 11.5563V9.15478Z'
            fill={color}
          />
          <path
            d='M49.8438 6.96991C49.8438 6.59072 49.7535 6.53655 49.4285 6.39209L48.5979 6.0129V5.61565L51.1439 4.87532H51.3967V12.423C51.3967 12.73 51.487 12.7661 52.5704 12.7661V13.5426H48.6701V12.7661C49.7535 12.7661 49.8438 12.73 49.8438 12.423V6.96991Z'
            fill={color}
          />
          <path
            d='M47.1628 13.3439L44.6168 13.7231H44.364V12.1161C43.8945 12.8745 42.8653 13.7231 41.7096 13.7231C39.6873 13.7231 38.333 11.8633 38.333 9.62425C38.333 6.69906 40.0845 4.87532 42.2874 4.87532C43.0458 4.87532 43.8764 5.18229 44.364 5.65176V2.09458C44.364 1.71539 44.2737 1.66122 43.9487 1.51677L43.118 1.13758V0.740327L45.664 0H45.9168V11.9897C45.9168 12.3689 46.0071 12.423 46.3321 12.5675L47.1628 12.9467V13.3439ZM39.9401 9.26311C39.9401 11.123 40.8248 12.5856 42.3055 12.5856C43.1903 12.5856 43.8403 12.098 44.364 11.4841V6.71711C43.9667 6.03096 43.2625 5.74205 42.5222 5.74205C40.9693 5.74205 39.9401 7.18659 39.9401 9.26311Z'
            fill={color}
          />
          <path
            d='M34.081 6.96991C34.081 6.59072 33.9907 6.53655 33.6657 6.39209L32.8351 6.0129V5.61565L35.3811 4.87532H35.6339V12.423C35.6339 12.73 35.7242 12.7661 36.8076 12.7661V13.5426H32.9073V12.7661C33.9907 12.7661 34.081 12.73 34.081 12.423V6.96991Z'
            fill={color}
          />
          <path
            d='M29.4859 12.7661V13.5426H25.0439V12.7661C26.1273 12.7661 26.2176 12.73 26.2176 12.423V6.96991C26.2176 6.59072 26.1273 6.53655 25.8023 6.39209L24.9717 6.0129V5.61565L27.5177 4.87532H27.7705V7.27687C28.3122 6.35598 29.4317 4.87532 30.4609 4.87532C31.2554 4.87532 31.6527 5.41703 31.6527 5.95873C31.6527 6.59072 31.2193 6.9338 30.6776 6.9338C30.172 6.9338 29.9553 6.41015 29.54 6.41015C29.0344 6.44626 28.258 7.3491 27.7705 8.07137V12.3869C27.7705 12.73 27.8608 12.7661 29.4859 12.7661Z'
            fill={color}
          />
          <path
            d='M23.2476 11.8091C22.6337 13.037 21.3336 13.7231 19.9974 13.7231C17.9389 13.7231 16.0791 12.098 16.0791 9.38951C16.0791 6.75323 17.9389 4.87532 19.9794 4.87532C22.1823 4.87532 23.2115 6.48238 23.2115 8.48668V9.06449H17.6139V9.11866C17.6139 11.448 18.896 12.6397 20.3405 12.6397C21.2794 12.6397 21.8934 12.2786 22.5795 11.3396L23.2476 11.8091ZM19.9071 5.76011C18.8418 5.76011 17.9028 6.62683 17.6681 8.26999H21.6948C21.6767 6.73517 21.1892 5.76011 19.9071 5.76011Z'
            fill={color}
          />
          <path
            d='M14.4273 1.62511V2.4196C13.0189 2.4196 12.8022 2.47377 12.8022 2.88908V12.2786C12.8022 12.6939 13.0189 12.7481 14.4273 12.7481V13.5426H9.4798V12.7481C10.8882 12.7481 11.1049 12.6939 11.1049 12.2786V2.546H11.0327L7.13242 13.6509H6.53654L2.74463 2.546H2.6724V12.2786C2.6724 12.6939 2.88908 12.7481 4.29751 12.7481V13.5426H0V12.7481C1.40843 12.7481 1.62511 12.6939 1.62511 12.2786V2.90714C1.62511 2.47377 1.40843 2.4196 0 2.43766V1.62511H4.135L7.13242 10.8882H7.20464L10.3285 1.62511H14.4273Z'
            fill={color}
          />
          <rect
            x='51.3351'
            y='0.869602'
            width='1.65157'
            height='1.63858'
            transform='rotate(90 51.3351 0.869602)'
            fill={color}
          />
          <rect
            x='35.6659'
            y='0.869602'
            width='1.65157'
            height='1.63858'
            transform='rotate(90 35.6659 0.869602)'
            fill={color}
          />
        </svg>
      )}
    </div>
  );
};
